import { Helmet } from 'react-helmet-async';

function PageTitle({ title = process.env.REACT_APP_TAB_NAME }) {
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
}

export default PageTitle;
